import chroma from "chroma-js";
const lighten = (color, ratio) => chroma.mix(color, "#fff", ratio).hex();
const darken = (color, ratio) => chroma.mix(color, "#000", ratio).hex();
export { darken, lighten };
